# frozen_string_literal: true

module Engine
  module Game
    module GSystem18
    end
  end
end
